import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from "@nosto/preact";
import { useState, useEffect } from "preact/hooks";
import { productImagePlaceholder } from "../helpers";

export default function Product({ product, wishlistItems }) {
  const { format } = useCurrencyFormatting();
  const [isInWishList, setIsInWishlist] = useState(false);

  const PFASbadge = product.tags1.find(tag => tag.includes("PFASFREE"));
  const MMbadge = product.tags1.find(tag => tag.includes("MMLOVES"));
  const newBadge = product.tags1.find(tag => tag.includes("New Arrivals"));
  const exclusiveBadge = product.tags1.find(tag => tag.includes("Minimax Exclusive"));

  const madeInFranceBadge = product.tags1.find(tag => tag.includes("Made In France"));
  const comingBadge = product.tags1.find(tag => tag.includes("COMINGSOON"));
  const thirdPartyBadge = product.tags1.find(tag => tag.includes("3rd Party Supplier"));

  function handleWishlist(prod) {
    var pId = prod.productId;
    var vId = prod.skus[0].id;
    var iwishpTitle = prod.name;
    let wishlistStorage = localStorage.getItem("iWishlistmain");
    let wishlist = JSON.parse(wishlistStorage);

    if (!isInWishList) {
      jQuery.ajax({
        url: "https://iwish.myshopapps.com/ajax/iwishAdd.php",
        data: {
          shop: "minimaxau.myshopify.com",
          cId: 7460317102114,
          pId: pId,
          vId: vId,
          pTitle: iwishpTitle,
          qty: 1
        },
        dataType: "jsonp",
        jsonpCallback: "iWishAddCallback"
      });

      wishlist[pId] = [vId];
      let updatedWishlist = JSON.stringify(wishlist);
      localStorage.setItem("iWishlistmain", updatedWishlist);
    } else {
      jQuery.ajax({
        url: "https://iwish.myshopapps.com/ajax/iwishRemove.php",
        data: {
          shop: "minimaxau.myshopify.com",
          cId: 7460317102114,
          pId: pId,
          vId: vId
        },
        dataType: "jsonp",
        jsonpCallback: "iWishRemoveCallback"
      });

      delete wishlist[pId];
      let updatedWishlist = JSON.stringify(wishlist);
      localStorage.setItem("iWishlistmain", updatedWishlist);
    }
  }

  useEffect(() => {
    if (wishlistItems) {
      if (JSON.parse(wishlistItems)[product.productId]) {
        setIsInWishlist(true);
      }
    }
  }, [wishlistItems]);

  return (
    <SerpElement
      as="a"
      hit={product}
      ariaLabel={`Product ${product.name}`}
      class="ns-product ns-border-box ns-clickable ns-text-undecorated ns-color-inherit ns-d-flex"
    >
      <div class="ns-img-wrapper ns-relative ns-w-100">
        <img class="ns-w-100" src={product.imageUrl ?? productImagePlaceholder} alt={product.name} />
        <div class="iwishAddWrap">
          <a
            class="iWishAdd"
            href="#"
            onClick={() => {
              setIsInWishlist(!isInWishList);
              handleWishlist(product);
            }}
          >
            {isInWishList ? (
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon heart-icon-full" viewBox="0 0 20 19">
                <path d="M10 19l-1.5-1.4C3.7 13.1 2 11.3.9 9.1.3 8 0 6.9 0 5.7 0 2.5 2.4 0 5.5 0 7.2 0 8.9.8 10 2.2 11.1.8 12.8 0 14.5 0 17.6 0 20 2.5 20 5.7c0 1.2-.3 2.3-.9 3.4-1.1 2.2-2.8 4-7.7 8.5L10 19z"></path>
              </svg>
            ) : (
              <svg aria-hidden="true" focusable="false" role="presentation" class="icon heart-icon" viewBox="0 0 20 19">
                <path d="M10 19l-1.5-1.4C3.7 13.1 2 11.3.9 9.1.3 8 0 6.9 0 5.7 0 2.5 2.4 0 5.5 0 7.2 0 8.9.8 10 2.2 11.1.8 12.8 0 14.5 0 17.6 0 20 2.5 20 5.7c0 1.2-.3 2.3-.9 3.4-1.1 2.2-2.8 4-7.7 8.5L10 19zM5.5 2C3.5 2 2 3.6 2 5.7c0 .8.2 1.6.7 2.5 1 1.8 2.3 3.3 7.2 8l.1.1.1-.1c4.9-4.6 6.3-6.1 7.2-8 .5-.9.7-1.7.7-2.5C18 3.6 16.5 2 14.5 2c-1.1 0-2.2.5-3 1.4L10 5.3 8.5 3.4C7.7 2.5 6.6 2 5.5 2z"></path>
              </svg>
            )}
          </a>
        </div>
        {/* {PFASbadge && (
          <div class="bss_pl_img ns-d-block">
            <img
              src="https://cdn.shopify.com/s/files/1/2176/1321/files/1750655005677-831530555-PFASFREE-Photoroom_565e70be-479d-4c1f-b921-20d9bdd94073.png?v=1750655221"
              alt="PFAS FREE"
              class="bss-pl-frontend bss-pl-top-left bss_pl_text_hover_link_disable ns-absolute ns-d-block"
              style="background-color: transparent; min-height: auto!important; transform-origin: center; opacity: 1; will-change: transform; z-index:4; width:20%!important; height:auto!important;"
            />
          </div>
        )}
        {MMbadge && (
          <div class="bss_pl_img ns-d-block">
            <img
              src="https://cdn.shopify.com/s/files/1/2176/1321/files/Artboard2.png?v=1730253243"
              alt="Minimax Loves"
              class="bss-pl-frontend bss-pl-top-left bss_pl_text_hover_link_disable ns-absolute ns-d-block"
              style="background-color: transparent; min-height: auto!important; transform-origin: center; opacity: 1; will-change: transform; z-index:4; width:15%!important; height:auto!important;"
            />
          </div>
        )}
        {newBadge && (
          <div class="bss_pl_img ns-d-block">
            <img
              src="https://d21m4dsqdd3b9h.cloudfront.net/shopify-21761321/onsiteContent/17556107408760.9800299821560182"
              alt="Minimax exclusive"
              class="bss-pl-frontend bss-pl-top-left bss_pl_text_hover_link_disable ns-absolute ns-d-block"
              style="background-color: transparent; min-height: auto!important; transform-origin: center; opacity: 1; will-change: transform; z-index:4; width:15%!important; height:auto!important;"
            />
          </div>
        )}
        {exclusiveBadge && (
          <div class="bss_pl_img ns-d-block">
            <img
              src="https://d21m4dsqdd3b9h.cloudfront.net/shopify-21761321/onsiteContent/17556102934980.5589767927251891"
              alt="Minimax exclusive"
              class="bss-pl-frontend bss-pl-top-left bss_pl_text_hover_link_disable ns-absolute ns-d-block"
              style="background-color: transparent; min-height: auto!important; transform-origin: center; opacity: 1; will-change: transform; z-index:4; width:15%!important; height:auto!important;"
            />
          </div>
        )}
        {madeInFranceBadge && (
          <div class="bss_pl_img ns-d-block">
            <img
              src="https://d21m4dsqdd3b9h.cloudfront.net/shopify-21761321/onsiteContent/17556102934990.35202565478047554"
              alt="Made in France"
              class="bss-pl-frontend bss-pl-top-left bss_pl_text_hover_link_disable ns-absolute ns-d-block"
              style="background-color: transparent; min-height: auto!important; transform-origin: center; opacity: 1; will-change: transform; z-index:4; width:15%!important; height:auto!important;"
            />
          </div>
        )}
        {comingBadge && (
          <div class="bss_pl_img ns-d-block">
            <img
              src="https://d21m4dsqdd3b9h.cloudfront.net/shopify-21761321/onsiteContent/17556102934980.9231907375761557"
              alt="Coming Soon"
              class="bss-pl-frontend bss-pl-top-left bss_pl_text_hover_link_disable ns-absolute ns-d-block"
              style="background-color: transparent; min-height: auto!important; transform-origin: center; opacity: 1; will-change: transform; z-index:4; width:15%!important; height:auto!important;"
            />
          </div>
        )}
        {thirdPartyBadge && (
          <div class="bss_pl_img ns-d-block">
            <img
              src="https://d21m4dsqdd3b9h.cloudfront.net/shopify-21761321/onsiteContent/17556102934970.3423046222949946"
              alt="Online exclusive"
              class="bss-pl-frontend bss-pl-top-left bss_pl_text_hover_link_disable ns-absolute ns-d-block"
              style="background-color: transparent; min-height: auto!important; transform-origin: center; opacity: 1; will-change: transform; z-index:4; width:15%!important; height:auto!important;"
            />
          </div>
        )} */}
      </div>
      <div class="ns-relative ns-product-info" data-nosto-element="product">
        <div class="ns-product-name">{product.name}</div>
        {product.ratingValue !== null && product.ratingValue !== 0 && (
          <div class="ns-review-container">
            <span class="product-rating" data-rating={product.ratingValue} aria-label={`Rated ${product.ratingValue} out of 5`}></span>
            <span class="ns-review-value">{parseInt(product.ratingValue).toFixed(1)}</span>
          </div>
        )}
        <div aria-label="Price" style="margin: 0 auto;">
          {product.listPrice && product.listPrice > product.price && <span class="ns-list-price ns-text-striked">{format(product.listPrice)}</span>}
          <span class={`ns-price ${product.onDiscount ? "has-compare-price" : ""}`}>{format(product.price)}</span>
        </div>
      </div>
    </SerpElement>
  );
}
